import { createSelector } from '@ngrx/store';

import { locationsFiltersState } from '../root';

export const getLocationFilterSelectedPickupTime = createSelector(locationsFiltersState, (locationsFilters) => locationsFilters?.pickupTime || null);
